// API Usage Checker - Add this to your browser console to check API usage anytime

// To check API usage, open browser console and type:
// checkApiUsage()

import apiUsageTracker from './apiUsageTracker';

// Export to window for easy console access
if (typeof window !== 'undefined') {
  window.checkApiUsage = () => {
    const stats = apiUsageTracker.getUsageStats();
    
    console.log('%c╔════════════════════════════════════════════╗', 'color: #00d4ff; font-weight: bold');
    console.log('%c║     CoinGecko API Usage Report             ║', 'color: #00d4ff; font-weight: bold');
    console.log('%c╠════════════════════════════════════════════╣', 'color: #00d4ff; font-weight: bold');
    
    // Last Minute
    const minuteColor = stats.lastMinute.status === 'critical' ? '#ff6b6b' : 
                        stats.lastMinute.status === 'warning' ? '#ffd93d' : '#51cf66';
    console.log(`%c║ Last 1 Minute:                             ║`, 'color: #00d4ff');
    console.log(`%c║   Calls: ${stats.lastMinute.calls}/${stats.lastMinute.limit} (${stats.lastMinute.percentage.toFixed(0)}%)`, `color: ${minuteColor}; font-weight: bold`);
    console.log(`%c║   Remaining: ${stats.lastMinute.remaining}                               ║`, `color: ${minuteColor}`);
    console.log(`%c║   Status: ${stats.lastMinute.status.toUpperCase()}                           ║`, `color: ${minuteColor}; font-weight: bold`);
    
    // Last 5 Minutes
    const min5Color = stats.last5Minutes.status === 'critical' ? '#ff6b6b' : 
                      stats.last5Minutes.status === 'warning' ? '#ffd93d' : '#51cf66';
    console.log('%c║                                            ║', 'color: #00d4ff');
    console.log('%c║ Last 5 Minutes:                            ║', 'color: #00d4ff');
    console.log(`%c║   Calls: ${stats.last5Minutes.calls}/${stats.last5Minutes.limit} (${stats.last5Minutes.percentage.toFixed(0)}%)`, `color: ${min5Color}; font-weight: bold`);
    console.log(`%c║   Remaining: ${stats.last5Minutes.remaining}                              ║`, `color: ${min5Color}`);
    console.log(`%c║   Status: ${stats.last5Minutes.status.toUpperCase()}                           ║`, `color: ${min5Color}; font-weight: bold`);
    
    // Last 15 Minutes
    const min15Color = stats.last15Minutes.status === 'critical' ? '#ff6b6b' : 
                       stats.last15Minutes.status === 'warning' ? '#ffd93d' : '#51cf66';
    console.log('%c║                                            ║', 'color: #00d4ff');
    console.log('%c║ Last 15 Minutes:                           ║', 'color: #00d4ff');
    console.log(`%c║   Calls: ${stats.last15Minutes.calls}/${stats.last15Minutes.limit} (${stats.last15Minutes.percentage.toFixed(0)}%)`, `color: ${min15Color}; font-weight: bold`);
    console.log(`%c║   Remaining: ${stats.last15Minutes.remaining}                             ║`, `color: ${min15Color}`);
    console.log(`%c║   Status: ${stats.last15Minutes.status.toUpperCase()}                           ║`, `color: ${min15Color}; font-weight: bold`);
    
    // Last Hour
    const hourColor = stats.lastHour.status === 'critical' ? '#ff6b6b' : 
                      stats.lastHour.status === 'warning' ? '#ffd93d' : '#51cf66';
    console.log('%c║                                            ║', 'color: #00d4ff');
    console.log('%c║ Last Hour:                                 ║', 'color: #00d4ff');
    console.log(`%c║   Calls: ${stats.lastHour.calls}/${stats.lastHour.limit} (${stats.lastHour.percentage.toFixed(0)}%)`, `color: ${hourColor}; font-weight: bold`);
    console.log(`%c║   Remaining: ${stats.lastHour.remaining}                            ║`, `color: ${hourColor}`);
    console.log(`%c║   Status: ${stats.lastHour.status.toUpperCase()}                           ║`, `color: ${hourColor}; font-weight: bold`);
    
    console.log('%c╚════════════════════════════════════════════╝', 'color: #00d4ff; font-weight: bold');
    console.log('%c\n💡 Tip: Your app uses caching (30s) to reduce API calls!', 'color: #51cf66; font-style: italic');
    console.log('%c\nCoinGecko Free Tier Info:', 'color: #ffd93d; font-weight: bold');
    console.log('%c  • Rate Limit: ~10-50 calls/minute (dynamic)', 'color: #ffffff');
    console.log('%c  • Your app caches responses for 30 seconds', 'color: #ffffff');
    console.log('%c  • Refresh button uses debouncing (500ms)', 'color: #ffffff');
    console.log('%c  • Consider upgrading to Pro for higher limits', 'color: #ffffff');
    
    return stats;
  };
  
  window.resetApiUsage = () => {
    apiUsageTracker.reset();
    console.log('%c✅ API usage tracker has been reset!', 'color: #51cf66; font-weight: bold; font-size: 14px');
  };
  
  console.log('%c🚀 API Usage Tracker Loaded!', 'color: #00d4ff; font-weight: bold; font-size: 16px');
  console.log('%cType %ccheckApiUsage()%c to see your current API usage', 'color: #ffffff', 'color: #ffd93d; font-weight: bold', 'color: #ffffff');
  console.log('%cType %cresetApiUsage()%c to reset the tracker', 'color: #ffffff', 'color: #ffd93d; font-weight: bold', 'color: #ffffff');
}

export default apiUsageTracker;
